import React, { useRef } from 'react'
import type {
  SearchFloatingPanelProps,
} from 'components/SearchV2/Components/Mobile/Panels/SearchFloatingPanel'
import SearchFloatingPanel from 'components/SearchV2/Components/Mobile/Panels/SearchFloatingPanel'
import styled from 'styled-components'
import { rem } from 'polished'
import Group from 'components/utils/Group'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import ExperiencesSearchDateSelectInline from 'components/Search/Experiences/ExperiencesSearchDateSelectInline'
import useExperienceSearchLabels from 'components/Experiences/hooks/useExperienceSearchLabels'

const ContentContainer = styled(Group)`
  padding-top: ${rem(20)};
  height: 100%;
`

interface Props
  extends Omit<
    SearchFloatingPanelProps,
    'title' | 'isConfirmButtonHidden' | 'children'
  > {
  confirmButtonDisabled: boolean
  title?: string
}

function ExperienceDateFloatingPanel(props: Props) {
  const {
    title,
    confirmButtonDisabled,
    ...floatingPanelProps
  } = props

  const { whenLabel } = useExperienceSearchLabels()
  const resolvedTitle = title ?? whenLabel
  const scrollerRef = useRef<HTMLDivElement>(null)

  return (
    <SearchFloatingPanel
      ref={scrollerRef}
      {...floatingPanelProps}
      title={resolvedTitle}
      confirmButtonDisabled={confirmButtonDisabled}
    >
      <ContentContainer direction="vertical" verticalAlign="space-between">
        <VerticalSpacer gap={24}>
          <ExperiencesSearchDateSelectInline
            calendarDirection="vertical"
            quickChipsDisplayType="multi-line"
            calendarScrollerRef={scrollerRef}
          />
        </VerticalSpacer>
      </ContentContainer>
    </SearchFloatingPanel>
  )
}

export default ExperienceDateFloatingPanel
